module.exports = __webpack_public_path__ + "3db2dba04e7ec51c70ed975c7ffb36f1.png";